// Components
import BasePage from "@/browser/pages/common/BasePage";
import RegisterContainer from "@/browser/components/vehicle/register/RegisterContainer";

const RegisterPage = () => {
  return (
    <BasePage>
      <RegisterContainer />
    </BasePage>
  );
};

export default RegisterPage;
